<template>
  <div
    v-show="visible"
    ref="popup"
    class="hmrag-evidence-popup"
    role="dialog"
    aria-label="Source evidence"
    :style="positionStyle"
    @click.stop
  >
    <div v-if="loading" class="evidence-state">Loading source…</div>
    <div v-else-if="error" class="evidence-state">{{ error }}</div>
    <div v-else-if="!quotes.length" class="evidence-state">No stored source quote is available.</div>
    <template v-else>
      <div v-for="(quote, index) in quotes" :key="index" class="evidence-item">
        <blockquote>{{ quote.quote }}</blockquote>
        <div class="evidence-source">
          source [{{ citationNumber }}]:
          <a
            v-if="sourceUrl(quote)"
            :href="sourceUrl(quote)"
            target="_blank"
            rel="noopener noreferrer"
          >{{ sourceLabel(quote) }} ↗</a>
          <span v-else>{{ sourceLabel(quote) }}</span>
        </div>
      </div>
    </template>
  </div>
</template>

<script>
export default {
  data: () => ({
    visible: false,
    loading: false,
    error: '',
    quotes: [],
    citation: null,
    citationNumber: null,
    top: 0,
    left: 0
  }),
  computed: {
    positionStyle() {
      return { top: `${this.top}px`, left: `${this.left}px` }
    }
  },
  mounted() {
    document.addEventListener('click', this.handleOutsideClick)
    window.addEventListener('resize', this.close)
  },
  beforeDestroy() {
    document.removeEventListener('click', this.handleOutsideClick)
    window.removeEventListener('resize', this.close)
  },
  methods: {
    open(anchor, options) {
      const data = options || {}
      this.citation = data.citation || null
      this.citationNumber = data.citationNumber
      this.quotes = data.quotes || []
      this.loading = !!data.loading
      this.error = data.error || ''
      this.visible = true
      this.positionAt(anchor)
    },
    setEvidence(quotes, citation) {
      this.quotes = quotes || []
      if (citation) this.citation = citation
      this.loading = false
      this.error = ''
    },
    setError(message) {
      this.loading = false
      this.error = message || 'Could not load the source.'
    },
    close() {
      this.visible = false
    },
    positionAt(anchor) {
      if (!anchor || !anchor.getBoundingClientRect) return
      const rect = anchor.getBoundingClientRect()
      const popupWidth = 420
      const edge = 12
      this.top = Math.min(rect.bottom + 7, window.innerHeight - 80)
      this.left = Math.max(edge, Math.min(rect.left, window.innerWidth - popupWidth - edge))
    },
    handleOutsideClick(event) {
      if (!this.visible) return
      if (event.target.closest && event.target.closest('a.evi')) return
      if (this.$refs.popup && !this.$refs.popup.contains(event.target)) this.close()
    },
    sourceUrl(quote) {
      return quote.source_url || (this.citation && this.citation.source_url) || ''
    },
    sourceLabel(quote) {
      return quote.doc_type || quote.label ||
        (this.citation && (this.citation.label || this.citation.doc_type)) || 'source'
    }
  }
}
</script>

<style scoped>
.hmrag-evidence-popup { background: #fff; border: 1px solid #c7ccd1; border-radius: 8px; box-shadow: 0 6px 24px rgba(0, 0, 0, .18); font-size: 13px; max-height: min(70vh, 520px); max-width: 420px; overflow-y: auto; padding: 12px 14px; position: fixed; width: calc(100vw - 24px); z-index: 220; }
.evidence-item + .evidence-item { border-top: 1px solid #e3e8ee; margin-top: 10px; padding-top: 4px; }
.evidence-item blockquote { background: #f6f8fb; border-left: 3px solid #1558d6; color: #1c2530; margin: 8px 0; padding: 7px 10px; }
.evidence-source { color: #5a6470; font-size: 12px; margin-top: 6px; }
.evidence-source a { color: #1558d6; text-decoration: none; }
.evidence-source a:hover { text-decoration: underline; }
.evidence-state { color: #5a6470; font-style: italic; padding: 5px 2px; }
</style>
